import { MyError } from "./MyError";


export class AuthError extends MyError {

    constructor(message: string, status: number = 0){
        super(message, status)
        this.name = 'AuthError';
    }
}
